import { render, staticRenderFns } from "./service-agreement-form.vue?vue&type=template&id=cfc67d1c&scoped=true"
import script from "./service-agreement-form.vue?vue&type=script&lang=js"
export * from "./service-agreement-form.vue?vue&type=script&lang=js"
import style0 from "./service-agreement-form.vue?vue&type=style&index=0&id=cfc67d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc67d1c",
  null
  
)

export default component.exports